import type {DesignSelection} from '@Components/social-media/social-media.types';
import type {DesignSelectorTab} from '@Components/design-selector/design-selector.types';

export const MAX_UPLOADS_TO_DESIGNS = 10;

export interface WizardDesignSelectorPanelProps {
  designsToPublish: DesignSelection[];
  onDesignListChange: (designs: DesignSelection[]) => void;
  onDesignsStaged: (designs: DesignSelection[]) => void;
  designSelectorTab: DesignSelectorTab;
  isMobileView: boolean;
}
